import React, { Component } from 'react';
import PicturePreview from './PicturePreview';
import $ from 'jquery';
import { connect } from 'react-redux';
import closeIcon from '../../images/icons/close_icon.svg';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import { HashRouter, Redirect } from 'react-router-dom';
import LivelinessTip from './livelinessTip'
import Result from './Result';
import { withTranslation } from 'react-i18next'
import SelfieTipOverlay from './selfieTipOverlay';
import IdTipOverlay from './idTipOverlay';
import front from "./assets/front.svg"
import right from "./assets/right.svg"
import left from "./assets/left.svg"
import front_icon from "./assets/front-icon.png"
import right_icon from "./assets/right-icon.png"
import left_icon from "./assets/left-icon.png"
import WebCamera from './WebCamera';
import { setTakeWebPicture } from '../../../action/action';
import audio from "../autoCheckin/assets/cameraClick.mp3"
import { WEB_VERSION_ENABLED } from '../../../config/constant';
import runRequestPermission from '../../JS/runRequestPermission';

class Camera extends Component {

    constructor(props) {
        super(props);
        this.state = {
            startVideo: false,
            takePicture: false,
            openCameraErr: false,
            displayMessage: null,
            inProgress: false,
            showLivelinessTip: true,
            tipIndex: 0,
            switchWebCam: false,
            cameraPermissionGranted: true,
            showCamera: false,
            hideTakePictureScreen: false
        }
        this.timeout = null;
        this.webPictureCount = 0
        this.isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        this.externalCameraSuccess = this.externalCameraSuccess.bind(this);
        this.externalCameraError = this.externalCameraError.bind(this);
    }


    openSettings = (name="application_details") => {
        this.props.backBtn();
        if (window.cordova && window.cordova.plugins.settings) {
            console.log('openNativeSettingsTest is active');
            window.cordova.plugins.settings.open(name, function() {
                    console.log('opened settings');
                    this.setState({goBack:true});
                },
                function () {
                    console.log('failed to open settings');
                }
            );
        } else {
            console.log('openNativeSettingsTest is not active!');
        }
    }


    openCamera = () => {
        const options = {
            x: 0,
            y: 0,
            width: window.screen.width,
            height: window.screen.height*(0.75),
            toBack: true,
            camera: this.props.selfie ? window.CameraPreview && window.CameraPreview.CAMERA_DIRECTION.FRONT : window.CameraPreview && window.CameraPreview.CAMERA_DIRECTION.BACK,
            tapPhoto: true,
            tapFocus: true,
            previewDrag: false,
            storeToFile: true,
            disableExifHeaderStripping: false
        }

        const platform = window.device ? window.device.platform: "web";
        if (this.props.useExternalCamera && platform === "iOS") {
            // var srcType = navigator.camera.PictureSourceType.CAMERA;
            // var externalOptions = this.setOptions(srcType); 
            this.setState({hideTakePictureScreen: true})
            let externalOptions = {
                quality: 50,
                targetWidth: window.screen.width,
                targetHeight: window.screen.height * (0.75),
                correctOrientation: true,
                saveToPhotoAlbum: false,
            }
            navigator.camera.getPicture(this.externalCameraSuccess, this.externalCameraError, externalOptions);
        }
        else if (window.CameraPreview) {
            window.CameraPreview.startCamera(options, this.successCalback, this.cameraErrCallback)
        }
        else this.setState({ showCamera: true })
    }

    externalCameraError(err) {
        console.log("camera error while taking picture", err);
        this.setState({ openCameraErr: true });
        this.props.hidePicturePreview();
    }

    externalCameraSuccess(imageUrl, isLast = false) {
        console.log("externalCameraSuccess: ",imageUrl);
        
        this.props.saveImage(imageUrl);
        this.setState({ takePicture: true, inProgress: false });
        // navigator.camera.cleanup(onCleanupSuccess, onCleanupFail);
        this.props.hidePicturePreview();

        // let files = [...this.state.images]
        // files.push(mediaFile);
        // this.setState({images: files});

        // if (isLast){
        //   this.setState({
        //     videoUrl: `${mediaFile}`,
        //     showPicturePreview: true 
        //   })
        //   this.props.setSelfieVideo({videoUrl: `${mediaFile}`, images: files});
        // console.log(`images: ${this.state.images.join(",")}`);
    }

    switchCamera = () => {
        if(WEB_VERSION_ENABLED){
            this.setState({switchWebCam: !this.state.switchWebCam})
        } else {
            window.CameraPreview.switchCamera(this.successCalback, this.errorCalback);
        }
    }

    requestCameraPermission = () => {

        if(window.CameraPreview){
            // runRequestPermission('CAMERA', (status) => {
            //     if(status){
            //         this.openCamera();
            //         this.setState({ cameraPermissionGranted: true });
            //     } else {
            //         this.setState({ cameraPermissionGranted: false });
            //     }
            // })
            this.openCamera();
        } else {
            this.openCamera();
        }
    }

    successCalback = (success) => {
        console.log("success", success);
        this.setState({ cameraPermissionGranted: true });
    }

    videoSuccessCalback = (success) => {
        console.log("success", success);
        this.timeout = setTimeout(() => { this.stopVideoHandler() }, 5000);
    }

    cameraErrCallback = (error) => {
        console.log("error", error);
        this.setState({ cameraPermissionGranted: false });
    }

    errorCalback = (error) => {
        console.log("error", error);
        this.setState({ openCameraErr: true });
    }

    playAudio = () => {
        new Audio(audio).play().catch((err) => console.log(err));
    }

    startVideo = () => {
        this.setState({ startVideo: true });
        const option = {
            cameraDirection: window.CameraPreview.CAMERA_DIRECTION.BACK,
            width: window.screen.width,
            height: window.screen.height,
            quality: 60,
            withFlash: false
        }

        window.CameraPreview.startRecordVideo(option, this.videoSuccessCalback);
    }

    stopVideoHandler = () => {
        console.log('stopHandler video called');
        this.setState({ startVideo: false });
        const self = this;
        window.CameraPreview.stopRecordVideo(function (filePath) {
            const platform = window.device.platform;
            if (platform == "Android") {
                filePath = "file://" + filePath;

            } else {
                filePath = filePath;
            }

            console.log("stop video", filePath);
            self.props.saveImage(filePath, true);
            self.setState({ takePicture: true, inProgress: false });
            window.CameraPreview.stopCamera();
        });
    }

    takePictureHandler = () => {

        let imageUrl;

        const platform = window.device.platform;

        window.CameraPreview.takePicture({ width: 960, height: 720, quality: 70 }, (image) => {
            if (platform == "Android") {
                imageUrl = "file://" + image[0];

            } else {
                imageUrl = image;
            }


            //    alert(imageUrl);

            console.log("camera preview take picture", imageUrl);
            this.props.saveImage(imageUrl);
            this.setState({ takePicture: true, inProgress: false });
            window.CameraPreview.stopCamera();
            //    window.CameraPreview.hide(this.successCalback);
        }, (err) => {
            console.log("camera preview error while taking picture", err);
            this.setState({ openCameraErr: true });
        });
    }

    takeMultiPictureHandler = (clickPicture) => {

        let imageUrl;

        const platform = window.device && window.device.platform;
        const total_pictures = 8;
        let i = 0;

        const pictureSuccess = (image) => {

            i += 1;


            window.CameraPreview.setFlashMode(window.CameraPreview.FLASH_MODE.OFF);

            if (platform == "Android") {
                imageUrl = "file://" + image[0];

            } else {
                imageUrl = image;
            }

            console.log(`${i} messages: ${this.props.messages}, displayMessage: ${this.state.displayMessage}`)
            if (i == 1 && this.props.messages && this.props.messages[0] && !this.state.displayMessage) {
                this.setState({ displayMessage: this.props.messages[0] })
            }

            if (i == 6 && this.props.messages && this.props.messages[1] && this.state.displayMessage) {
                this.setState({ displayMessage: this.props.messages[1] })
            }

            if (i < total_pictures) {
                console.log(`taking new picture: ${i}`);
                takePicture();
                this.props.saveImage(imageUrl, false);
            } else {
                this.props.saveImage(imageUrl, true);
                this.setState({ takePicture: true });
                window.CameraPreview.stopCamera();
                this.setState({ inProgress: false });
            }

        }

        const webPictureSuccess = () => {
            console.log("takePicture", this.webPictureCount , clickPicture);

            this.webPictureCount = this.webPictureCount + 1;
            

            if (this.webPictureCount == 1 && this.props.messages && this.props.messages[0] && !this.state.displayMessage) {
                this.setState({ displayMessage: this.props.messages[0] })
            }

            if (this.webPictureCount == 6 && this.props.messages && this.props.messages[1] && this.state.displayMessage) {
                this.setState({ displayMessage: this.props.messages[1] })
            }

            console.log( this.webPictureCount , total_pictures )
            if (this.webPictureCount < total_pictures) {
                this.props.saveImage(clickPicture, false);
                this.props.setTakeWebPicture(true);
            } else {
                this.props.saveImage(clickPicture, true);
                this.setState({ takePicture: true });
                this.setState({ inProgress: false });
            }
        }


        const takePicture = async () => {

            if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true" ){
                if ( this.webPictureCount < 3) {
                    // left
                    this.playAudio()
                    setTimeout(() => {
                        this.setState({ tipIndex: 1 })
                        webPictureSuccess()
                    }, 1000)
                } else if (this.webPictureCount == 6 || this.webPictureCount == 7) {
                    // front
                    this.setState({ tipIndex: 0 })
                    this.playAudio()
                    setTimeout(() => {
                        webPictureSuccess()
                    }, 1000)
                } else if (this.webPictureCount == 3) {
                    // right
                    this.setState({ tipIndex: 0 })
                    setTimeout(() => {
                        this.setState({ tipIndex: 2 })
                        this.playAudio()
                    },2000)
                    setTimeout(() => {
                        webPictureSuccess()
                    }, 3000)
                } else if (this.webPictureCount >= 4 && this.webPictureCount < 6) {
                    // right
                    this.setState({ tipIndex: 2 })
                    this.playAudio()
                    setTimeout(() => {
                        webPictureSuccess()
                    }, 1000)
                }
            } else {

            if (i < 3) {
                // left
                setTimeout(() => {
                    this.setState({ tipIndex: 1 })
                    window.CameraPreview.takePicture({ width: window.screen.width, height: window.screen.height, quality: 65 }, pictureSuccess);
                }, 1000)
            } else if (i == 6 || i == 7) {
                // front
                this.setState({ tipIndex: 0 })
                setTimeout(() => {
                    window.CameraPreview.takePicture({ width: window.screen.width, height: window.screen.height, quality: 65 }, pictureSuccess);
                }, 1000)
            } else if (i == 3) {
                // right
                this.setState({ tipIndex: 0 })
                setTimeout(() => {
                    this.setState({ tipIndex: 2 })
                },2000)
                setTimeout(() => {
                    window.CameraPreview.takePicture({ width: window.screen.width, height: window.screen.height, quality: 65 }, pictureSuccess);
                }, 2500)
            } else if (i >= 4 && i < 6) {
                // right
                this.setState({ tipIndex: 2 })
                setTimeout(() => {
                    window.CameraPreview.takePicture({ width: window.screen.width, height: window.screen.height, quality: 65 }, pictureSuccess);
                }, 1000)
            }}
        }

        takePicture();

    }

    componentDidUpdate() {
        mobileCheckinColorConfig(this.props.menuColor);
    }

    componentWillUnmount() {
        $("html").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("body").attr('style', `background: ${this.props.menuColor.backgroundColor} !important`);
        $("#app-body").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("#root").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("body").css("color", this.props.menuColor.assetFontColor);
        $("#root").css(`background: ${this.props.menuColor.backgroundColor}`);
        window.CameraPreview && window.CameraPreview.stopCamera();
    }

    componentDidMount(){
        $("html").attr('style', `background: transparent !important`);
        $("body").attr('style', `background: transparent !important`);
        $("#app-body").attr('style', `background: transparent !important`);
        $("#root").attr('style', `background: transparent !important`);
        $("#root").css("background-color", "transparent !important");
        this.requestCameraPermission();
        // window.screen.orientation.lock('portrait');
        mobileCheckinColorConfig(this.props.menuColor);
    }

    render() {
        const { t } = this.props
        document.addEventListener("backbutton", (e) => { e.preventDefault(); }, false);

        console.log("this.state.showCamera", this.state.showCamera);

        return (
            <>
            {this.props.selfie && this.state.showLivelinessTip && !this.props.changeProfilePhoto ? <LivelinessTip backBtn={() => this.setState({ showLivelinessTip: false })} /> : null}
            {this.state.openCameraErr ? <Result heading={this.props.heading} message={t('camera.error_texts')} backBtn={this.props.backBtn} />

                : !this.state.openCameraErr && this.state.takePicture ? <PicturePreview image={this.props.image} video={this.props.recordVideo}
                    selfie={this.props.selfie} nextScreen={this.props.nextScreen} nextPath={this.props.nextPath} backBtn={() => {
                        this.webPictureCount = 0;
                        this.props.changeProfilePhoto && this.props.saveImage(localStorage.getItem('profile_photo') || null);
                        this.setState({ takePicture: false, tipIndex: 0 , displayMessage: null });
                        this.openCamera();
                    }}
                    hidePicturePreview={this.props.hidePicturePreview} 
                    switchUsingNextScreen={this.props.switchUsingNextScreen}
                    />

                    : !this.state.hideTakePictureScreen && <div className="main-container" >

                        {this.state.showCamera && <WebCamera takePicture={(imageUrl) => {
                            if (!this.props.recordVideo) {
                                if (this.props.click_single_picture == true) {
                                    this.playAudio()
                                    this.props.saveImage(imageUrl);
                                    this.setState({ takePicture: true, inProgress: false });
                                } else {
                                    this.takeMultiPictureHandler(imageUrl)
                                }
                            } else {
                                console.log('starting capturing video');

                                this.startVideo();
                            }
                            this.setState({ inProgress: true });
                        }} goBack={() => this.props.backBtn()} selfie={this.props.selfie} direction={this.props.recordVideo !== undefined ? (this.props.recordVideo ? this.state.switchWebCam ? "user" : "environment" : this.props.selfie ? 'user': !this.state.switchWebCam ? "environment" : "user") : this.isMobile ? "environment" : 'user'} setImage={(imageUrl) => {this.props.saveImage(imageUrl);this.setState({ takePicture: true, inProgress: false });}}/>}

                        {this.state.displayMessage && <p style={{ color: "#fff", fontSize: "25px", position: "fixed", top: "10px", left: "10px", zIndex: "5" }}>{this.state.displayMessage}</p>}
                        <img src={closeIcon} className="id_image_delete_icon" onClick={this.props.backBtn} style={{ position: 'fixed', top: '10px', right: '10px', width: '30px', zIndex: '5' }} />

                        {this.props.selfie && <i onClick={this.switchCamera} class="fas fa-sync-alt" style={{ color: "#fff", fontSize: "25px", position: "fixed", top: "60px", right: "10px", zIndex: "5" }}></i>}

                        {!this.props.recordVideo && this.props.click_single_picture != true && this.state.tipIndex == 0 && 
                            <SelfieTipOverlay 
                                subClass='selfie-front' 
                                overlayImage={
                                    <svg width="376" height="587" viewBox="0 0 376 587" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                                } 
                                directiveArrows={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="3" height="362" viewBox="0 0 3 362" fill="none">
                                        <path d="M1 1C1.75462 119.51 2.8111 357.425 1 361" stroke="white" stroke-width="2"/>
                                    </svg>
                                }
                                icon={front_icon} 
                                texts="Look straight" 
                            />
                        }

                        {!this.props.recordVideo && this.props.click_single_picture != true && this.state.tipIndex == 1 && 
                            <SelfieTipOverlay 
                                subClass='selfie-left' 
                                overlayImage={
                                    <svg width="372" height="584" viewBox="0 0 372 584" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                                } 
                                directiveArrows={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="219" height="360" viewBox="0 0 219 360" fill="none">
                                        <path d="M216.342 195.657C216.929 195.294 217.699 195.475 218.063 196.061C218.426 196.648 218.245 197.419 217.658 197.782L216.342 195.657ZM-4.70877e-06 196.72L14.3544 195.208L8.4865 208.395L-4.70877e-06 196.72ZM217.658 197.782C187.295 216.593 104.77 242.489 9.79338 202.445L10.7646 200.142C104.904 239.832 186.579 214.096 216.342 195.657L217.658 197.782Z" fill="white"/>
                                        <path d="M113.9 359C94.6353 307.614 67.6642 164.075 113.9 0.99999" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                    </svg>
                                }
                                icon={left_icon} 
                                texts="Rotate your head slightly to the left" 
                            />
                        }

                        {!this.props.recordVideo && this.props.click_single_picture != true && this.state.tipIndex == 2 && 
                            <SelfieTipOverlay 
                                subClass='selfie-right' 
                                overlayImage={
                                    <svg width="374" height="590" viewBox="0 0 374 590" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                                } 
                                directiveArrows={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="222" height="360" viewBox="0 0 222 360" fill="none">
                                        <path d="M2.6518 195.653C2.06272 195.293 1.29336 195.479 0.933387 196.068C0.573411 196.657 0.75913 197.426 1.3482 197.786L2.6518 195.653ZM222 196.72L207.653 195.138L213.457 208.354L222 196.72ZM1.3482 197.786C32.1376 216.601 115.847 242.507 212.176 202.399L211.215 200.091C115.714 239.855 32.8438 214.103 2.6518 195.653L1.3482 197.786Z" fill="white"/>
                                        <path d="M106.525 359C126.056 307.614 153.4 164.075 106.525 0.99999" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                    </svg>
                                }
                                icon={right_icon} 
                                texts="Rotate your head slightly to the right" 
                            />
                        }

                        {!this.props.recordVideo && this.props.click_single_picture == true && this.props.idCapture &&
                            <IdTipOverlay 
                                selectedIdType={this.props.selectedId} 
                            />
                        }

                        {!this.state.showCamera && <footer className="button-controls footer-overlay">
                            <section className="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div className="form-row">
                                    {this.state.cameraPermissionGranted ?
                                        <p>{!this.props.selfie ? "Please take the picture in landscape" : ""}</p>
                                        : <p>We are unable to access camera. <text style={{textDecoration:'underline'}} onClick={() => this.openSettings()}>Enable camera permission</text> for the app from the phone's Settings.</p>
                                    }
                                </div>
                                {this.state.cameraPermissionGranted && !this.state.inProgress && <button className="primary w-100 all-caps" disabled={this.state.inProgress} onClick={(event) => {

                                    if (!this.props.recordVideo) {
                                        if (this.props.click_single_picture == true) {
                                            this.takePictureHandler()
                                        } else {
                                            this.takeMultiPictureHandler()
                                        }
                                    } else {
                                        console.log('starting capturing video');

                                        this.startVideo();
                                    }
                                    this.setState({ inProgress: true });
                                }}>{t('camera.take_picture')}</button>}
                                {!this.state.cameraPermissionGranted && <button onClick={() => this.props.backBtn()} className="primary w-100 all-caps">Return</button> }
                                {/* <button  className="primary w-100 all-caps" onClick = {() => window.CameraPreview.show(this.successCalback)}>show</button> */}
                                {/* <button  className="primary w-100 all-caps" onClick = {() => window.CameraPreview.hide(this.successCalback)}>hide </button> */}
                                {/* {this.props.selfie && <button className="primary w-100 all-caps margin-top-1" onClick = {this.switchCamera}>Switch camera</button>} */}
                                {/* <button disabled = {this.state.startVideo} className="primary w-100 all-caps margin-top-1" onClick = {this.startVideo}>Start video</button> */}
                                {/* <button disabled = {!this.state.startVideo} className="secondary w-100 all-caps margin-top-1" onClick = {this.stopVideoHandler}>Stop video</button> */}
                            </section>
                        </footer>}
                    </div>}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor
    }
}

export default connect(mapStateToProps,{ setTakeWebPicture })(withTranslation('translations')(Camera));